import useSWR from "swr";
import { swrKey } from "@/lib/swr";
import { isAssetUrl, type SignAssetsResponse } from "@/lib/assets";

const signOpts = { revalidateOnFocus: false, dedupingInterval: 10 * 60 * 1000 };

/**
 * Resolve an image src for rendering: a private-bucket reference
 * (https://storage.googleapis.com/<bucket>/…) is swapped for a short-lived
 * signed URL via GET /assets/sign-urls (SWR dedupes per ref, 10min < the
 * 15min TTL); any other URL (Feishu avatars…) passes through unchanged.
 * Returns undefined while a bucket ref is still being signed or failed.
 */
export const useSignedAssetUrl = (src?: string | null): string | undefined => {
  const needsSign = isAssetUrl(src ?? undefined);
  const { data } = useSWR<SignAssetsResponse>(
    needsSign ? swrKey("/assets/sign-urls", { refs: src }) : null,
    signOpts
  );
  if (!src) return undefined;
  return needsSign ? data?.results?.[0]?.url : src;
};
